// Generated by CoffeeScript 2.4.1
(function() {
  var POST, Weaver, WeaverBranch, WeaverObject, enc, getBranchUid;

  Weaver = require('./Weaver');

  WeaverObject = require('./WeaverObject');

  POST = Weaver.POST;

  enc = encodeURIComponent;

  getBranchUid = function(o) {
    if (o instanceof WeaverBranch) {
      return o.id();
    } else {
      return o;
    }
  };

  WeaverBranch = class WeaverBranch extends WeaverObject {
    constructor(uid, name, params = {}) {
      super(uid, name);
      this._protected = false;
      this._baseBranchUid = getBranchUid(params.baseBranch || params.baseBranchUid) || null;
      if (params.protected != null) {
        this._protected = params.protected;
      }
      if (params.target != null) {
        this._projectId = params.target;
      }
    }

    static async list(target) {
      var b, i, len, list, results;
      list = (await POST("v2.projects", {
        method: "GET",
        path: "/branches"
      }, target));
      results = [];
      for (i = 0, len = list.length; i < len; i++) {
        b = list[i];
        results.push(WeaverBranch._loadFromResult(b, {target}));
      }
      return results;
    }

    static async load(branchUid, params = {}) {
      var branchObject;
      branchObject = (await POST("v2.projects", {
        method: "GET",
        path: `/branches/${enc(branchUid)}`
      }, params.target));
      return WeaverBranch._loadFromResult(branchObject, params);
    }

    static _loadFromResult(object, params) {
      return new Weaver.Branch(object.uid, object.name, {
        baseBranchUid: object.baseBranchUid,
        protected: object._protected,
        target: params.target
      });
    }

    static createBranch(uid, name, params = {}) {
      return POST("v2.projects", {
        method: "POST",
        path: "/branches",
        body: {
          uid: uid,
          name,
          baseBranchUid: getBranchUid(params.baseBranch || params.baseBranchUid)
        }
      }, params.target);
    }

    static deleteBranch(uid, params = {}) {
      var ref;
      if (((ref = Weaver.getInstance().currentBranch()) != null ? ref.id() : void 0) === uid) {
        Weaver.getInstance().resetBranch();
      }
      return POST("v2.projects", {
        method: "DELETE",
        path: `/branches/${enc(uid)}`
      }, params.target != null ? params.target : this._projectId);
    }

    static diffBranches(intoBranch, fromBranch, params = {}) {
      return POST("v2.projects", {
        method: "POST",
        path: `/branches/${enc(intoBranch.id())}/merge/${enc(fromBranch.id())}`,
        body: {
          commitMsg: 'dryrun merge',
          dryrun: true,
          includeStagedWrites: false,
          includeSquashedWrites: true
        }
      }, params.target);
    }

    static mergeBranches(intoBranch, fromBranch, params = {}) {
      return POST("v2.projects", {
        method: "POST",
        path: `/branches/${enc(intoBranch.id())}/merge/${enc(fromBranch.id())}`,
        body: {
          commitMsg: params.commitMsg,
          includeStagedWrites: params.includeStagedWrites,
          includeSquashedWrites: params.includeSquashedWrites
        }
      }, params.target);
    }

    save() {
      return WeaverBranch.createBranch(this.id(), this.name(), {
        baseBranchUid: this._baseBranchUid
      });
    }

    destroy() {
      return WeaverBranch.deleteBranch(this.id(), {
        target: this._projectId
      });
    }

    static protectBranch(uid, params) {
      return POST("v2.projects", {
        method: "PUT",
        path: `/branches/${enc(uid)}`,
        body: params
      }, params.target);
    }

    protect() {
      this._protected = true;
      return WeaverBranch.protectBranch(this.id(), {
        _protected: this._protected,
        target: this._projectId
      });
    }

    unprotect() {
      this._protected = false;
      return WeaverBranch.protectBranch(this.id(), {
        _protected: this._protected,
        target: this._projectId
      });
    }

    isProtected() {
      return this._protected;
    }

    getBaseBranchUid() {
      return this._baseBranchUid;
    }

  };

  module.exports = WeaverBranch;

}).call(this);
